import { createSelector } from 'reselect';

export default class SiteSelectors {
    static getSitesInTransit = (s) => s.sites.sitesInTransit;

    static getSites = function (s) {
        return s.sites.all_sites;
    };

    static getSelectedSiteId = (s) => s.sites.selectedSiteId;

    static getSelectedSite = createSelector(
        SiteSelectors.getSites,
        SiteSelectors.getSelectedSiteId,
        (sites, siteId) => sites.find((site) => site.id === siteId)
    );

    static showAlert = (_store) => _store.sites.showAlert;
    static getServerId = (_store) => _store.sites.serverId;
    static getHostId = (_store) => _store.sites.hostId;
    static getAlertMessage = (_store) => _store.sites.alertMessage;
}



// WEBPACK FOOTER //
// ./app/selectors/sites.js